import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Hidden,
  IconButton,
  Link,
  Toolbar
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
// import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import { useHistory } from 'react-router';
import LogoutIcon from '@mui/icons-material/Logout';
import useAuth from 'src/context/AuthContext';
import FMSModal from 'src/common/FMSModal';

export const LogoutModal = ({ open, onClose }) => {
  const { signout } = useAuth();

  return (
    <FMSModal
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={onClose}
    >
      <DialogTitle sx={{ fontSize: 16 }} id="logout-dialog-title">
        Logout
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="logout-dialog-description">
          Are you sure, you want to logout?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={signout} autoFocus>
          Logout
        </Button>
      </DialogActions>
    </FMSModal>
  );
};

LogoutModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const history = useHistory();
  // const [notifications] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const showLogoutModal = () => setShowAlert(true);
  const handleAlertClose = () => setShowAlert(false);

  return (
    <AppBar elevation={0} {...rest}>
      <Toolbar>
        <Link
          component="button"
          underline="none"
          variant="h6"
          onClick={() => history.push('/app/dashboard')}
          sx={{
            color: 'white',
            fontSize: 22,
            mr: 2,
            fontWeight: 800,
            display: 'flex',
          }}
        >
          PRUDENT FUELS
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <Hidden lgDown>
          {/* <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
          <IconButton color="inherit" onClick={showLogoutModal}>
            <LogoutIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
      <LogoutModal open={showAlert} onClose={handleAlertClose} />
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
